import { txt } from "@/lib/format";
import { imgSrc, imgSrcSet } from "@/lib/media";

const ALIGN = { start: "items-start text-start", center: "items-center text-center", end: "items-end text-end" };

export const Hero = ({ s, lang }) => {
  const h = s.hero;
  const headline = txt(h, "headline", lang);
  const sub = txt(h, "subtitle", lang);
  const promo = txt(h, "promo", lang);
  if (!h.enabled || (!h.image_url && !headline && !sub)) return null;
  const o = h.overlay;
  return (
    <section data-testid="hero-section" className="mx-auto max-w-6xl px-4 pt-4 sm:px-6">
      <div className="wt-hero relative overflow-hidden" style={{ borderRadius: "calc(var(--wt-radius) + 8px)", background: "var(--wt-surface)" }}>
        {h.image_url && (
          <img src={imgSrc(h.image_url, "lg")} srcSet={imgSrcSet(h.image_url)} sizes="(min-width:1152px) 1152px, 100vw" alt="" fetchPriority="high" data-testid="hero-image" className="absolute inset-0 h-full w-full object-cover" />
        )}
        <div
          className="absolute inset-0"
          style={{ background: `linear-gradient(to top, color-mix(in srgb, var(--wt-bg) ${Math.min(o + 30, 100)}%, transparent) 0%, color-mix(in srgb, var(--wt-bg) ${o}%, transparent) 45%, color-mix(in srgb, var(--wt-bg) ${Math.round(o / 3)}%, transparent) 100%)` }}
        />
        <div className={`relative flex h-full flex-col justify-end gap-2 p-5 sm:gap-3 sm:p-8 ${ALIGN[h.align]}`}>
          {promo && (
            <span data-testid="hero-promo" className="rounded-full px-3 py-1 text-xs font-bold text-white" style={{ background: "var(--wt-primary)" }}>
              {promo}
            </span>
          )}
          {headline && <h1 data-testid="hero-headline" className="max-w-2xl text-3xl font-black leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">{headline}</h1>}
          {sub && <p data-testid="hero-subtitle" className="max-w-xl text-sm opacity-85 sm:text-base">{sub}</p>}
        </div>
      </div>
    </section>
  );
};
